import { isNil } from 'lodash'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { Alert } from 'features/alerts/types/alert'
import { DomainDTO } from 'features/inventory/api/types/domainDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { Domain } from 'features/inventory/types/domain'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'

type Data = {
  node: null | Pick<DomainDTO, 'alerts'>
}
type Variables = {
  id: DomainDTO['id']
}

export const useGetFreshDomainAlerts = ({
  domainId,
}: {
  domainId?: Domain['id']
}): Alert<DomainAlert>[] => {
  const { data } = useQuery<Variables, Data, Alert<DomainAlert>[]>({
    options: {
      enabled: domainId !== undefined,
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: ({ node }: Data): Alert<DomainAlert>[] => {
        if (isNil(node)) {
          return []
        }

        return alertsFromDTO<DomainAlert>(node.alerts)
      },
    },
    query: gql`
      query getFreshDomainAlerts($id: ID!) {
        node(id: $id) {
          ... on Domain {
            alerts {
              name
              description
            }
          }
        }
      }
    `,
    variables: { id: domainId! },
  })

  return data ?? []
}
